<div class="form-container">
  <div class="header-container">
    <div class="font-semibold text-xl">
      Additional details
    </div>
  </div>
  <form [formGroup]="form">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>

    <button type="submit" pButton class="custom-upload-button  btn-primary mt-6" [disabled]="isLoading" (click)="onSubmit()">
      {{ checkServiceAdvisorId && checkServiceAdvisorId != 0 ? "Update" : "Finish" }}
      <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
    </button>
  </form>
  <div *ngIf="isLoading" class="overlay">
    <div class="spinner">
      <div class="spinner-bar"></div>
    </div>
  </div>
</div>